// import MainContainer from "../../components/partials/maincontainer";
// import Input, { TextArea } from "../../components/partials/inputs";
// import { useLocation } from "react-router-dom";

// const RequestDetails = () => {
//   const { state } = useLocation();

//   // console.log({ state });

//   return (
//     <div>
//       <MainContainer>
//         <div>
//           <h1 className="text-3xl font-semibold text-sec">Invite Details</h1>
//           <p className="text-base font-normal text-es-gray-100 my-2">
//             Kindly review the provided details ggg
//           </p>
//           <form action="" className="mt-6">
//             <div className="space-y-4 w-96">
//               <Input
//                 bg="#F9FAFB"
//                 label="Enter Organisation Name*"
//                 footer="Do not enter abbreviations"
//                 placeholder="Kantango Limited"
//                 value={state?.user?.organizationName}
//                 readonly
//               />
//               <Input
//                 bg="#F9FAFB"
//                 label="Enter Focal Person Email*"
//                 placeholder="Larryngo@gmail.com"
//                 value={state?.user?.email}
//                 readonly
//               />
//               {state?.country && (
//                 <Input
//                   bg="#F9FAFB"
//                   label="Country of Operation*"
//                   placeholder="Nigeria"
//                   value={state?.country}
//                   readonly
//                 />
//               )}
//             </div>
//           </form>
//         </div>
//       </MainContainer>
//     </div>
//   );
// };

// export default RequestDetails;
import React from "react";

const ignore = () => {
  return <div>ignore</div>;
};

export default ignore;
